import { render, staticRenderFns } from "./CourseDetailPage.vue?vue&type=template&id=4b78c056&"
import script from "./CourseDetailPage.vue?vue&type=script&lang=js&"
export * from "./CourseDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports